import "isomorphic-fetch";
import promise from 'es6-promise';
promise.polyfill();


export const post = (url, data) => {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).catch(err => {
        console.log(err);
        throw err;
    });
};
